import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const UsagePricingCardContainer = styled.div`
    display: none;
    width: 100%;
    ${media.mobileDevice`
        display: flex;
        flex-direction: column;
    `}
`;

export const UsagePricingContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: space-between;
`;
export const UsagePricingFullWidth = styled.div`
    display: flex;
    width: 100%;
`;

export const UsagePricingDataContainer = styled.div`
    display: flex;
    height: ${({ height }) => (height ? height : 'auto')};
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    width: ${({ width }) => (width ? width : '100%')};
    margin: ${({ margin }) => (margin ? margin : '0')};
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'flex-start'};
    align-items: ${({ alignItems }) => alignItems};
`;

export const UsagePriceFont = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    display: inline-block;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    color: ${({ color }) => (color ? color : '#000000')};
    text-decoration: ${({ textDecoration }) =>
        textDecoration ? textDecoration : 'none'};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '0px'};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '20px')};
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    opacity: ${({ opacity }) => (opacity ? opacity : '1')};
    cursor: ${({ cursor }) => cursor};
`;

export const UsagePricingSummary = styled.div`
    display: flex;
    width: 100%;
`;
